import React from 'react';
import { AngleDownIcon } from 'react-line-awesome';
import { Select } from 'antd';
import { useStores } from '@gtintel/platform-stores';
import styles from './styles.module.scss';
const ProjectTypeSelect = props => {
  const {
    onChange,
    value
  } = props;
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectTypes
  } = adminProjectDetailStore;
  return <Select getPopupContainer={trigger => trigger.parentNode} suffixIcon={<AngleDownIcon />} onChange={onChange} placeholder="Select Project Type" size="large" className={styles.mediumInput} value={value}>
      {Object.values(projectTypes) && Object.values(projectTypes).map(projectType => {
      const ptype = projectType;
      return <Select.Option key={ptype?.id} value={ptype?.id} label={ptype?.name}>
              {ptype?.name}
            </Select.Option>;
    })}
    </Select>;
};
export default ProjectTypeSelect;